// Packages
import React, { useCallback, useEffect } from "react"
import PropTypes from "prop-types"

//	Configs
import ModalConfig from "components/Stacker/config/ModalConfig"
import ToggleConfig from "components/Stacker/config/ToggleConfig"
import ProductDetailsConfig from "components/Stacker/config/ProductDetailsConfig"

// Actions
import { toggleModal } from "components/Stacker/actions/ModalActions"
import {
  setSelectedSize,
  getPriceAndInventory,
} from "components/Stacker/actions/ProductDetailActions"
import { refineSize } from "components/Stacker/actions/StackerActions"

//	Components
import DropDown from "components/Stacker/components/DropDown/DropDown"
// import ProductSizeChart from 'components/pdp/ProductSizeChart/ProductSizeChart';

//	Styles
import "./ProductSizes.scss"

import { useDispatch } from "react-redux"
import { useContext } from "react"
import { StackerContext } from "components/DYStackers/StackerContext"
import { useI18nContext } from "i18n/i18n-react"
import SizeChart from "../Bracelets/SizeChart/SizeChart"
import SizeModal from "../Common/Modals/SizeModal"

// this will hold the Product Sizes on PDP page.
function ProductSizes({
  isQuickView,
  isShowError = false,
  pid,
  productSizeChart,
  selectedSize,
  selectedSize: { code } = {},
  baseStore,
  shouldUpdateDataLayer,
  shouldUpdateQuickViewLayer,
  entryNumber,
  isEditCart,
  refinerId = null,
  productSizes,
  isCsAgent,
}) {
  const dispatch = useDispatch()
  const { LL } = useI18nContext()
  const stackerContext = useContext(StackerContext)

  useEffect(() => {
    if (code) {
      getInventoryCodes({
        productId: code,
        pid,
      })
    }
  }, [code, pid])

  const getInventoryCodes = useCallback(
    (options) => {
      const { productId, pid } = options

      dispatch(
        getPriceAndInventory(
          {
            productId,
            productType: ProductDetailsConfig.VARIANT_PRODUCT,
            pid,
            baseStore,
            shouldUpdateDataLayer,
            shouldUpdateQuickViewLayer,
          },
          stackerContext.retailerId
        )
      )
    },
    [dispatch]
  )

  const handleSelection = useCallback(
    (sizeObj) => {
      const { size } = sizeObj
      const sizeData = { pid, sizeObj, isEditCart, entryNumber }
      if (size === "toggle_size_modal") {
        dispatch(toggleModal(`${pid}_${ModalConfig.MODAL_SIZE_CHART}`, true))
      } else if (refinerId) {
        dispatch(refineSize({ ...sizeData, refinerId }))
      } else {
        dispatch(setSelectedSize(sizeData))
      }
    },
    [dispatch]
  )

  const displaySizeChart = useCallback(() => {
    dispatch(toggleModal(ModalConfig.MODAL_SIZE_CHART, true))
  }, [dispatch])

  const formattedDropDownItems = () => {
    const formmatedSizes = productSizes.map((sizeObj) => {
      let label =
        sizeObj.size === ProductDetailsConfig.NO_SIZE
          ? ProductDetailsConfig.ONE_SIZE
          : `${sizeObj.size}`

      return {
        ...sizeObj,
        label,
      }
    })
    return formmatedSizes
  }

  let selectedItem
  if (selectedSize) {
    const sizeLabel =
      selectedSize.size === ProductDetailsConfig.NO_SIZE
        ? ProductDetailsConfig.ONE_SIZE
        : selectedSize.size
    selectedItem = sizeLabel
  }

  const shouldShowSizeChart =
    !isQuickView && productSizeChart && Object.keys(productSizeChart).length > 0
  const sizeDropDownOptions = formattedDropDownItems()
  // const sizeChartLabel = {
  //   size: "toggle_size_modal",
  //   label: LL.pdp.seeSizeChartLabel(),
  // }
  // const updatedSizeDropDownOptions = shouldShowSizeChart
  //   ? [...sizeDropDownOptions, sizeChartLabel]
  //   : [...sizeDropDownOptions]
  const updatedSizeDropDownOptions = [...sizeDropDownOptions]
  const dropId = refinerId || pid
  const toggleId = `${dropId}_${ToggleConfig.SIZE_DROPDOWN_TOGGLE}`

  return (
    <div className="ProductSizes">
      <div className="size-selector d-flex align-items-center">
        <div className="col-3 no-padding">
          <label className="text-black" htmlFor="sizeSelectorLabel">
            {LL.productConfig.sizeLabel()}
          </label>
        </div>
        <div className="col-6 col-md-7 size-select-cont">
          <DropDown
            id={toggleId}
            label={LL.productConfig.sizeLabel()}
            selectedItem={selectedItem}
            items={updatedSizeDropDownOptions}
            itemAction={handleSelection}
            isShowError={isShowError}
            isNotFormComponent
          />
        </div>
        {shouldShowSizeChart && (
          <div className="col-3 size-chart-button no-padding">
            <button className="c-btn text-black" onClick={displaySizeChart}>
              {LL.pdp.sizeChartText()}
            </button>
          </div>
        )}
        <SizeModal modalName={ModalConfig.MODAL_SIZE_CHART}>
          <SizeChart
            title={LL.pdp.braceletSize(
              stackerContext.gender.charAt(0).toUpperCase() +
                stackerContext.gender.slice(1)
            )}
          />
        </SizeModal>
      </div>

      {isShowError && (
        <p className="size-error error-text text-black">
          {LL.pdp.sizeSelectionErrorText()}
        </p>
      )}

      {/*{shouldShowSizeChart && (*/}
      {/*	<ProductSizeChart productSizeChart={productSizeChart} pid={pid} />*/}
      {/*)}*/}
    </div>
  )
}

ProductSizes.defaultProps = {
  shouldUpdateDataLayer: false,
}

ProductSizes.propTypes = {
  baseStore: PropTypes.string,
  entryNumber: PropTypes.string,
  isCsAgent: PropTypes.bool,
  isEditCart: PropTypes.bool,
  isQuickView: PropTypes.bool,
  isShowError: PropTypes.bool,
  pid: PropTypes.string.isRequired,
  productSizeChart: PropTypes.object,
  productSizes: PropTypes.array,
  refinerId: PropTypes.string,
  selectedSize: PropTypes.object,
  shouldUpdateDataLayer: PropTypes.bool,
  shouldUpdateQuickViewLayer: PropTypes.bool,
}

export default ProductSizes
